<template>
    <div class="relative" :class="wrapperWidth">
        <div
            :class="[
                'group flex items-center w-full rounded-full border bg-white transition-all',
                'px-4', // horizontal padding
                sizeClass, // height & text sizing
                ringClass, // ring on focus/error
                hovered ? 'shadow-sm' : '',
                disabled
                    ? 'opacity-60 cursor-not-allowed'
                    : 'hover:border-new-300',
            ]"
        >
            <i
                v-if="icon"
                :class="['mr-2 text-[#777777]', icon, iconSizeClass]"
            />

            <!-- default slot for input/select/custom -->
            <div class="flex-1 min-w-0">
                <slot />
            </div>

            <!-- right addon (opsional) -->
            <div v-if="$slots.right" class="ml-2 shrink-0">
                <slot name="right" />
            </div>
        </div>

        <!-- helper/error text -->
        <p v-if="error" class="mt-1 text-xs text-red-500">{{ error }}</p>
        <p v-else-if="hint" class="mt-1 text-xs text-gray-500">{{ hint }}</p>
    </div>
</template>

<script>
export default {
    name: "BasePillField",
    props: {
        icon: { type: String, default: "" },
        size: { type: String, default: "md" }, // sm|md|lg
        disabled: { type: Boolean, default: false },
        error: { type: String, default: "" },
        hint: { type: String, default: "" },
        wrapperClass: { type: String, default: "" }, // extra utility class
        width: { type: String, default: "" }, // override responsive width, else use wrapperClass
        hovered: { type: Boolean, default: true },
    },
    computed: {
        sizeClass() {
            switch (this.size) {
                case "sm":
                    return "h-10 text-sm";
                case "lg":
                    return "h-12 text-sm";
                default:
                    return "h-11 text-sm";
            }
        },
        iconSizeClass() {
            switch (this.size) {
                case "sm":
                    return "text-base";
                case "lg":
                    return "text-lg";
                default:
                    return "text-[15px]";
            }
        },
        ringClass() {
            return this.error
                ? "border-red-400 focus-within:ring-2 focus-within:ring-red-300 focus-within:border-red-400"
                : "border-new-200 focus-within:ring-2 focus-within:ring-secondary/40 focus-within:border-secondary";
        },
        wrapperWidth() {
            // prefer width prop; fallback to wrapperClass for responsive control
            return this.width || this.wrapperClass;
        },
    },
};
</script>
